import {ITag, ITagForCreation, ITagParent} from '../models';
import { api } from './Api';

export const getTags = () => {
  return api.get('/tag/suggestions/').then(res => res.data);
};

export const createTag = ({ tag, parent = null }: { tag: ITagForCreation; parent: ITagParent | null }) => {
  if (!parent) {
    return api.post('/tag/', tag)
      .then((res: any) => res.data)
      .then((data: any) => ({
        tags: [{
          id: data.id,
          name: data.result.name,
          uid: data.result.uid,
        }],
      }));
  }
  return api.post(`/tag/${parent.objectType}/${parent.objectId}/`, [ tag.name ]).then(res => res.data);
};

export const updateTag = (uid: string, tag: Partial<ITag>) => {
  return api.put(`/tag/${uid}`, tag).then((res: any) => res.data);
};

export const removeTag = ({ uid, parent = null }: { uid: string; parent: ITagParent | null }) => {
  if (!parent) {
    return api.delete(`/tag/tag/${uid}/`).then((res: any) => res.data);
  }
  const payload = {
    data: {
      tag_uids: [uid]
    }
  };
  return api.delete(`/tag/${parent.objectType}/${parent.objectId}/`, payload).then((res: any) => res.data);
};
